module.exports = __webpack_public_path__ + "img/14.329a4c28.jpg";